import React from "react";
import { HeaderContainer } from "./style";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import MainContext from "../../contexts/main";
const Header = () => {
  const [menuStatus, setMenuStatus] = React.useState(false);
  const { user } = React.useContext(MainContext);

  return (
    <HeaderContainer menuStatus={menuStatus}>
      <Container>
        <div className="top">
          <Link to="/">
            <img src="/images/logo.png" alt="logo" className="logo" />
          </Link>
          <div className="welcome">به صفحه رسمی فروش آرین دیزل خوش آمدید.</div>
        </div>
      </Container>
      <div className="content">
        <Container>
          <nav>
            <div className="menu-area">
              <FiMenu
                className="menu-icon"
                onClick={() => setMenuStatus(true)}
              />
              <div className="overlay" onClick={() => setMenuStatus(false)} />
              <ul className="menu">
                <li>
                  <Link to="/sell">خرید خودرو</Link>
                </li>
                <li>
                  <Link to="/circulars">اطلاعیه فروش</Link>
                </li>
              </ul>
            </div>
            <div className="panel-link">
              {(user && user.show_sample) &&
              <a href="/pdf/sample.zip" target={'_blank'} className={'mx-5 d-inline-block'}>دانلود نمونه پیشنویس قرارداد</a>
              }
              <Link to="/profile">
                پنل کاربری
              </Link>
            </div>
          </nav>
        </Container>
      </div>
    </HeaderContainer>
  );
};
export default Header;
